<template>
	<div :class="inputStyleType ? [inputStyleType] + ' input-box ' + [contClass] : 'input-box ' + [contClass]">
		<label v-if="labelValue" class="input-label">{{ labelValue }}</label>
		<div class="input-cont">
			<input
				:id="id"
				:placeholder="placeHolder"
				:type="type"
				:minlength="minlength"
				:maxlength="maxlength"
				:inputStyleType="inputStyleType"
				:required="isRequired"
				:readonly="isReadonly"
				v-model="inputVal"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: "input-box",
	props: {
		id: String,
		placeHolder: String,
		// eslint-disable-next-line vue/require-prop-type-constructor
		type: "date" | "email" | "number" | "password" | "text" | "tel" | "textarea",
		minlength: Number,
		maxlength: Number,
		value: String,
		labelValue: String,
		// eslint-disable-next-line vue/require-prop-type-constructor
		inputStyleType: "round" | "sharp",
		required: Boolean,
		readonly: Boolean,
		contClass: String,
	},
	computed: {
		isReadonly: {
			get() {
				return this.readonly && this.readonly.toString().toLowerCase() === "true";
			},
		},
		isRequired: {
			get() {
				return this.required && this.required.toString().toLowerCase() === "true";
			},
		},
		inputVal: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.input-box {
	width: 100%;
	margin: 10px auto;
	.input-cont {
		position: relative;
		display: flex;
		input {
			border: 1px solid var(--white);
			color: var(--black);
			border-radius: 40px;
			height: 65px;
			max-width: 500px;
			width: 100%;
			font-family: Poppins;
			font-style: normal;
			font-weight: 500;
			font-size: 18px;
			line-height: 27px;
			text-align: left;
			padding-left: 15px;
			outline: none;
		}
		input::placeholder {
			font-family: "Poppins";
			font-style: italic;
			color: var(--text);
		}
	}
}
.sharp.input-box {
	margin: 15px auto;
	.input-cont input {
		border: 1px solid #dbdee7;
		box-sizing: border-box;
		border-radius: 6px;
		// width: 290px;
		height: 60px;
		font-family: Poppins;
		font-style: normal;
		font-weight: 300;
		font-size: 16px;
		line-height: 200%;
		color: var(--black);
	}
	input::placeholder {
		font-family: "Poppins";
		font-style: italic;
		color: var(--text);
	}

	input:read-only {
		border: none;
	}
}
@media screen and (max-width: 414px) {
	.input-box {
		.input-cont input {
			border-radius: 40px;
			height: 60px;
		}
	}
}
</style>
